"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CardSectionHeader = _interopRequireDefault(require("../CardSectionHeader/CardSectionHeader"));
var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Component for easily adding a ReCaptcha to a Formik form.
 * @documentation https://github.com/ELEVATORmedia/duffel-bag/wiki/FormikReCaptcha
 */
var ReCaptcha = _ref => {
  var {
    googleRecaptchaKey,
    form: {
      setFieldValue,
      setFieldTouched
    }
  } = _ref;
  var onChange = response => {
    setFieldValue('recaptcha', response, true);
    setFieldTouched('recaptcha', true);
  };
  var onError = () => {
    setFieldValue('recaptcha', '', true);
    setFieldTouched('recaptcha', true);
  };
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    flexDirection: 'column',
    minHeight: '75px'
  }, /*#__PURE__*/_react.default.createElement(_CardSectionHeader.default, {
    sectionTitle: 'CAPTCHA'
  }), /*#__PURE__*/_react.default.createElement(_reactGoogleRecaptcha.default, {
    sitekey: googleRecaptchaKey,
    onChange: onChange,
    onErrored: onError,
    onExpired: onError
  }));
};
var _default = exports.default = ReCaptcha;